import {useContactForm} from './ContactFormContext.jsx';
import {useMemo} from 'react';
import {Alert, Link} from 'bonprix-design-system';
import Url from '@core/scripts/helper/url';

export function ConcernInfoText() {
    const {formValues, setFormValues} = useContactForm();

    const subjectConcernValue = `${formValues.subjectIndex}-${formValues.concernIndex}`;

    const infoText = useMemo(() => {
        switch (subjectConcernValue) {
            case '1-1':
                return 'Schreib uns bitte, an welcher Stelle Du nicht weiterkommst..';
            case '1-2':
                return (
                    <>
                        Wenn Du einzelne Artikel hinzufügen oder stornieren möchtest, gehe einfach in{' '}
                        <Link href={Url.toAbsolute('/buy/login/?target=%2Fmyaccount%2Foverview%2F')} target="_blank">
                            Mein Konto
                        </Link>{' '}
                        und schaue nach, ob Du neben dem entsprechenden Artikel den Aktionsbutton „Artikel stornieren“
                        siehst. Solange Dir dieser Button angezeigt wird, ist die Bestellung stornierbar. Ist dieser
                        Button nicht mehr zu finden, ist eine Stornierung, auch durch unseren Kundenservice nicht mehr
                        möglich. In diesem Fall kannst Du die Annahme des Pakets verweigern oder die Artikel einfach
                        retournieren, die du nicht behalten möchtest. Ausführlichere Informationen findest Du{' '}
                        <Link href={Url.toAbsolute('/service/lieferung/')} target="_blank">
                            hier
                        </Link>{' '}
                        unter dem Punkt „Wie kann ich meine Bestellung ändern oder stornieren?“.
                    </>
                );
            case '1-3':
                return (
                    <>
                        Den aktuellen Status Deiner Sendung kannst Du unter{' '}
                        <Link href={Url.toAbsolute('/myaccount/overview/')} target="_blank">
                            "Mein Konto"
                        </Link>{' '}
                        oder unter{' '}
                        <Link href="https://www.myhermes.de/empfangen/sendungsverfolgung/" target="_blank">
                            "Sendungsverfolgung"
                        </Link>{' '}
                        unter Angabe Deiner Sendungsnummer überprüfen. Außerdem erhältst Du eine Benachrichtigung von
                        Hermes per E-Mail oder als Karte im Briefkasten, solltest Du nicht angetroffen worden sein.
                    </>
                );
            case '1-4':
                return (
                    <>
                        Wir freuen uns, dass Du in unserem Webshop oder Katalog etwas gefunden hast und bei uns
                        bestellen möchtest. Eine Bestellkarte gibt es nicht mehr. Der Grund dafür ist, dass sich das
                        Bestellverhalten unserer Kund*innen seit vielen Jahren verändert hat und wir darauf reagieren
                        mussten. Immer mehr Kund*innen nutzen die Möglichkeit des Online-Shoppings, um sich über unser
                        vielfältiges Angebot zu informieren. Probiere es gerne einfach mal aus und besuche unseren{' '}
                        <Link href={Url.toAbsolute('/')} target="_blank" target="_blank">
                            Online Shop
                        </Link>
                        .
                    </>
                );
            case '2-1':
                return (
                    <>
                        Deine Rechnung findest Du{' '}
                        <Link href={Url.toAbsolute('/myaccount/invoices/')} target="_blank">
                            hier
                        </Link>
                        .<br />
                        <strong>Achtung: Wir verzichten bewusst auf den Versand einer Papier-Rechnung.</strong>
                    </>
                );
            case '2-2':
                return (
                    <>
                        Es dauert je nach Bank 2-7 Tage bis das Geld bei uns eingegangen ist. Nach dieser Zeit forschen
                        wir gern nach, dafür benötigen wir unbedingt folgende Informationen:
                    </>
                );
            case '2-3':
                return 'Um dein Anliegen klären zu können, benötigen wir folgende Informationen:';
            case '2-4':
                return (
                    <>
                        Es dauert je nach Bank ca. 2-7 Tage bis das Geld bei uns eingegangen ist. Nach dieser Zeit
                        forschen wir gern nach, dafür benötigen wir unbedingt folgende Informationen:
                    </>
                );
            case '2-5':
                return (
                    <>
                        Es dauert 2-4 Tage bis der Betrag auf der Kreditkarte belastet wird. Wichtig: Bitte sende uns
                        keine Kreditkartendaten der Karteninhabenden. Falls wir weitere Infos brauchen, werden wir diese
                        separat anfordern.
                    </>
                );
            case '2-6':
                return (
                    <>
                        Es dauert je nach Bank ca. 2 Tage bis das Geld bei uns eingegangen ist. Nach dieser Zeit
                        forschen wir gern nach, dafür benötigen wir unbedingt folgende Informationen:
                    </>
                );
            case '2-7':
                return (
                    <>
                        Unser Tipp: Im Bereich{' '}
                        <Link href={Url.toAbsolute('/myaccount/overview/')} target="_blank">
                            "Mein Konto"
                        </Link>{' '}
                        kannst Du jederzeit Deinen aktuellen Kontostand online einsehen.
                    </>
                );
            case '2-9':
                return 'Nenne uns bitte Deine Bankdaten.';
            case '3-1':
                return (
                    <>
                        Hier findest Du alle Informationen zu Retouren: Klicke einfach{' '}
                        <Link href={Url.toAbsolute('/service/ruecksendung/')} target="_blank">
                            hier
                        </Link>
                        . (Und noch ein Tipp: Mit unserem neuen digitalen Retourenservice wird Deine Rücksendung viel
                        schneller bearbeitet. Weitere Informationen dazu findest Du unter der Überschrift "Neuer
                        Retourenservice – papierlos, kostenfrei, online". Wenn Du dennoch Fragen hast, schreib uns
                        einfach eine Nachricht. Damit wir Dir gezielt antworten können, gib bitte die Rechnungsnummer
                        und das Rechnungsdatum des Artikels, den du zurücksenden möchtest, in die angegebenen Felder
                        ein.
                    </>
                );
            case '3-2':
                return (
                    <>
                        Wir bitten um Dein Verständnis, wenn in seltenen Einzelfällen die Bearbeitungszeit auch mal
                        länger dauern kann. Melde Dich gerne bei uns, wenn Du nach 2 Wochen noch keine Gutschrift
                        erhalten hast. Während dieser Zeit brauchst Du uns nicht zu informieren, denn nach erfolgter
                        Gutschrift schicken wir Dir eine E-Mail.
                    </>
                );
            case '3-3':
                return (
                    <>
                        Retournierst Du Deine komplette Bestellung, erstatten wir Dir auch die Versandkosten. Besteht
                        Deine Bestellung aus mehreren Sendungen, kann die Gutschrift der Versandkosten deshalb erst dann
                        erfolgen, wenn sämtliche Artikel aus allen Sendungen komplett retourniert wurden.
                    </>
                );
            case '3-4':
                return 'Schreibe uns bitte, welcher Artikel fehlerhaft ist und nenne uns die Rechnungsnummer.';
            case '3-5':
                return 'Schreib uns bitte, welcher Artikel fehlt oder falsch geliefert wurde und nenn uns die Rechnungsnummer.';
            case '4-1':
                return (
                    <>
                        Du hast Fragen zur Anmeldung/zum Log-In? Wir haben die Antworten.
                        <Link href={Url.toAbsolute('/service/fragen-zur-anmeldung-strich-zum-log-in/')} target="_blank">
                            Hier
                        </Link>{' '}
                        findest Du die Antworten auf alle Fragen, die wir am häufigsten gestellt bekommen. Sollte Deine
                        Frage dennoch unbeantwortet bleiben, schick uns gerne eine Nachricht. Teile uns mit, an welcher
                        Stelle Du nicht weiterkommst und vergiss bitte nicht die Felder „Straße und Hausnummer“ und „PLZ
                        und Ort“ auszufüllen.
                    </>
                );
            case '4-2':
                return (
                    <>
                        Im Bereich{' '}
                        <Link href={Url.toAbsolute('/myaccount/overview/')} target="_blank">
                            "Mein Konto"
                        </Link>{' '}
                        kannst Du Deine persönlichen Daten selbst ändern.
                    </>
                );
            case '4-3':
                return (
                    <>
                        Schade, dass wir Dich als Kund*in verlieren. Hast Du Dich über uns geärgert? Schreib uns doch
                        gerne was schiefgelaufen ist und gib uns noch einmal die Möglichkeit zu reagieren. Wir würden
                        das dann gern in Ordnung bringen! Bitte nenne uns auf jeden Fall Deine vollständige Anschrift,
                        damit wir uns darum kümmern können.
                    </>
                );
            case '5-1':
                return 'Nenne uns bitte die Artikelnummer.';
            case '5-2':
                return 'Die genaue Ersatzteilbezeichnung findest Du in der Aufbauanleitung oder direkt beim Artikel im Shop.';
            case '5-3':
                return 'Nenne uns bitte die Artikelnummer';
            case '6-1':
                return (
                    <>
                        Auf unseren Serviceseiten kannst Du Dich für unseren{' '}
                        <Link href={Url.toAbsolute('/service/newsletter/')} target="_blank">
                            Newsletter
                        </Link>{' '}
                        anmelden.
                    </>
                );
            case '6-2':
                return (
                    <>
                        Auf unseren Serviceseiten kannst Du Dich für unseren{' '}
                        <Link href={Url.toAbsolute('/service/newsletter/abmelden/')} target="_blank">
                            Newsletter
                        </Link>{' '}
                        abmelden. Außerdem findest Du in jedem unserer Newsletter einen Abmeldelink.
                    </>
                );
            case '6-3':
                return (
                    <>
                        Wir können leider keine individuellen Anfragen für den Katalogversand entgegennehmen. Die
                        Auswahl für den Katalogversand erfolgt automatisch und wir haben keinen manuellen Einfluss
                        darauf. Unser Geschäftsmodell konzentriert sich zunehmend auf den Online-Handel, da wir so
                        schneller auf Trends und Kundenwünsche reagieren können. Gleichzeitig tragen wir durch die
                        Reduzierung des Papierverbrauchs zur Schonung der Umwelt bei. Aus diesem Grund können wir keine
                        individuellen Anfragen für den Katalogversand bearbeiten. Stattdessen empfehlen wir Ihnen,
                        unseren{' '}
                        <Link href={Url.toAbsolute('/')} target="_blank">
                            Online-Shop
                        </Link>{' '}
                        oder unseren{' '}
                        <Link href={Url.toAbsolute('/service/newsletter/')} target="_blank">
                            Newsletter
                        </Link>{' '}
                        als Alternative zu nutzen. Wir hoffen auf Ihr Verständnis.
                    </>
                );
            case '6-4':
                return 'Nenne uns bitte Deine Kundennummer oder vollständige Anschrift.';
            case '7-1':
                return 'Nenne uns bitte den Gutscheincode oder den Newsletter-Betreff und die Höhe des Rabatts';
            case '7-2':
                return (
                    <>
                        <Link href={Url.toAbsolute('/service/gutschein/')} target="_blank">
                            Hier
                        </Link>{' '}
                        findest Du alle Informationen zu Einlösebedingungen.
                    </>
                );
            case '8-1':
                return 'Es ist kein passendes Anliegen für Dich dabei? Dann schreib uns gern hier, was wir für Dich tun können.';
        }
    });

    if (formValues.concernIndex === '0' || !infoText) {
        return null;
    }

    return (
        <div>
            <Alert isOpen severity="info" showCloseIcon={false}>
                {infoText}
            </Alert>
        </div>
    );
}
